import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Main from '@/main/Main'
import Login from '@/login/Login'
import Regist from '@/regist'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/hello',
      name: 'Hello',
      component: HelloWorld
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    //regist
    {
      path: '/regist',
      name: 'Regist',
      component: Regist,
      children: [
        {
          path: '/regist/telregist',
          name: 'telRegist',
          component: () => import('@/regist/TelRegist.vue'),
        },
        {
          path: '/main/detail',
          name: 'Details',
          component: () => import('@/regist/Details')
        },
        {
          path: '/regist/settingpassword',
          name: 'settingPassword',
          component: () => import('@/regist/SettingPassword.vue'),
        },
        {
          path: '/regist/resetpassword',
          name: 'resetPassword',
          component: () => import('@/regist/ResetPassword.vue'),
        },
        {
          path: '/regist/conformpassword',
          name: 'conformPassword',
          component: () => import('@/regist/ConformPassword.vue'),
        },
        {
          path: '/regist',
          redirect: '/regist/telregist'
        }
      ]
    },
    //main
    {
      path: '/main',
      name: 'Main',
      component: Main,
      children: [
        {
          path: '/main/index',
          name: 'Index',
          component: () => import('@/main/index')
        },
        {
          path: '/main/application',
          name: 'Application',
          component: () => import('@/main/application')
        },
        //印章管理
        {
          path: '/main/certificat/emanagement',
          name: 'CertificateManagement',
          component: () => import('@/main/certificatemanagement')
        },
        //收费详情
        {
          path: '/main/logmanagement/AccountDetail',
          name: 'AccountDetail',
          component: () => import('@/main/logmanagement/AccountDetail')
        },
        //要闻动态
        {
          path: '/main/focus/news',
          name: 'FocusNews',
          component: () => import('@/main/focusNews')
        },
        //日志管理
        {
          path: '/main/log/management',
          name: 'LogManagement',
          component: () => import('@/main/logmanagement')
        },
        //印章管理
        {
          path: '/main/seal/management',
          name: 'SealManagement',
          component: () => import('@/main/Sealmanagement')
        },
        //申领印章
        {
          path: '/applySeal/uplicense',
          name: 'Uplicense',
          component: () => import('@/applyseal/UpLicense'),
        },
        //印章管理-企业人员管理
        {
          path: '/main/seal/management/enterprise',
          name: 'EnterprisePersonnelManagement',
          component: () => import('@/main/Sealmanagement/EnterprisePersonnelManagement')
        },
        //选择印章申领
        {
          path: '/main/seal/management/selectSeals',
          name: 'selectSeals',
          component: () => import('@/main/Sealmanagement/selectSeals'),
        },
        //申领印章等待
        {
          path: '/applySeal/waitLicense',
          name: 'WateLicense',
          component: () => import('@/applyseal/WateLicense'),
        },
        {
          path: '/main/seal/management',
          name: 'SealFaceSwiping',
          component: () => import('@/main/Sealmanagement/SealFaceSwiping')
        },
        {
          path: '/main/face/swiping',
          name: 'FaceSwiping',
          component: () => import('@/main/Sealmanagement/FaceSwiping')
        },
        //实名认证
        {
          path: '/main/seal/management',
          name: 'SealAuthentication',
          component: () => import('@/main/Sealmanagement/SealAuthentication')
        },
        {
          path: '/main/AlreadyAuthentication',
          name: 'AlreadyAuthentication',
          component: () => import('@/main/Sealmanagement/AlreadyAuthentication')
        },
        //我要签章
        {
          path: '/main/signature',
          name: 'Signature',
          component: () => import('@/main/signature/SignationFile'),
        },
        //签章下载
        {
          path: '/main/signature/down',
          name: 'SignationDown',
          component: () => import('@/main/signature/SignationDown'),
        },
        //我要验签
        {
          path: '/main/verification',
          name: 'Verification',
          component: () => import('@/main/verification'),
          children: [
            {
              path: '/main/verification',
              name: 'VerificationMain',
              component: () => import('@/main/verification/Verification'),
            },
            {
              path: '/main/verification',
              name: 'VerificationDesc',
              props: true,
              component: () => import('@/main/verification/VerificationDesc'),
            },
          ]
        },
        {
          path: '/main',
          redirect: '/main/index'
        }
      ]
    },
    //authentication
    {
      path: '/authentication',
      name: 'Authentication',
      component: () => import('@/authentication'),
      children: [
        {
          path: '/authentication/agent/company/info',
          name: 'AgentCompanyInfo',
          component: () => import('@/authentication/AgentCompanyInfo'),
        },
        // {
        //   path: '/authentication/apply/fpr/seal',
        //   name: 'ApplyForSeal',
        //   component: () => import('@/authentication/ApplyForSeal.vue'),
        // },
        {
          path: '/authentication/apply/seal',
          name: 'AuApplySeal',
          component: () => import('@/authentication/ApplySeal'),
        },
        {
          path: '/authentication/legal',
          name: 'Legal',
          component: () => import('@/authentication/Legal'),
        },
        {
          path: '/authentication/legal/face/swiping',
          name: 'LegalFaceSwiping',
          component: () => import('@/authentication/LegalFaceSwiping'),
        },
        {
          path: '/authentication/legal/info',
          name: 'LegalInfo',
          component: () => import('@/authentication/LegalInfo'),
        },
        {
          path: '/authentication',
          redirect: '/authentication/legal'
        }
      ]
    },
    {
      path: '/',
      redirect: '/main'
    },
    {
      path: '*',
      redirect: '/main'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js